import { forwardRef, HTMLAttributes } from 'react'
import tw from 'tailwind-styled-components'
import styled from 'styled-components'
import { theme } from '../../config'

type Props = HTMLAttributes<HTMLInputElement> & {
  hint?: string
}

const Container = tw.div`
  flex
  flex-1
`
const LabelContainer = tw.div`flex flex-col flex-1`
const Title = tw.p<{ $hint?: string }>`
  text-sm
  text-gray-800
  ${({ $hint }) => ($hint ? 'mb-1' : '')}
`
const Hint = tw.p`text-sm text-gray-700`
const Handle = tw.span`relative inline-block mr-3 w-[40px] h-[24px]`
const Label = tw.label<{ $centered?: string }>`
  flex
  cursor-pointer
  ${({ $centered }) => ($centered ? '' : 'items-center')}
`
const Input = tw.input`w-0 h-0 opacity-0`
const Span = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${theme.colors.gray[400]};
  transition: 0.3s;
  border-radius: 24px;

  &:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: ${theme.colors.white};
    transition: 0.3s;
    border-radius: 50%;
  }

  input:checked + & {
    background-color: ${theme.colors.green[500]};
  }

  input:checked + &:before {
    transform: translateX(16px);
  }
`

export const Switch = forwardRef<HTMLInputElement, Props>(
  ({ title, hint, className, ...props }, ref) => (
    <Container className={className}>
      <Label $centered={hint}>
        <Handle>
          <Input type='checkbox' ref={ref} {...props} />
          <Span />
        </Handle>
        <LabelContainer>
          <Title $hint={hint}>{title}</Title>
          {hint && <Hint>{hint}</Hint>}
        </LabelContainer>
      </Label>
    </Container>
  )
)
